export default __webpack_public_path__ + "static/media/or_2.b3db00dd.mp3";